import { createPopper } from '@popperjs/core';
import Cookies from 'js-cookie';
import $ from 'jquery';

export default class FilterPopups {
  constructor() {
    const $popups = $('[data-popup]');

    if ($popups.length) {
      const $document = $(document);
      const $window = $(window);
      const $body = $('body');

      $popups.each(function () {
        const $button = $(this);
        const popupSelector = $button.data('popup');
        const $popup = $(popupSelector);
        const $arrow = $popup.find('.filter-popup-arrow');

        if (!Cookies.get(popupSelector)) {
          createPopper(this, $popup[0], {
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'arrow',
                options: {
                  element: $arrow[0]
                }
              },
              {
                name: 'offset',
                options: {
                  offset: [0, 15]
                }
              }
            ]
          });
          $popup.addClass('show');

          // Events
          const removePopup = () => {
            ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $window).off('scroll.popup');
            $document.off('click.popup');
            $popup.removeClass('show');
            Cookies.set(popupSelector, true, { expires: 1 / 24 });
          };

          // Execution
          setTimeout(() => {
            $document.on('click.popup', ({ target }) => {
              if (target !== $popup[0]) {
                removePopup();
              }
            });
            ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $window).on('scroll.popup', () => {
              if ($document.scrollTop() > 100) {
                removePopup();
              }
            });
          }, 500);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/filter-popup.js